import { makeAutoObservable, runInAction } from 'mobx'

import { LoadClientTendersTask } from '../Tasks/LoadClientTendersTask'

import type { TenderRecord } from '../Contracts/ITender'

/**
 * Тендери одного клієнта для вкладки «Тендер» його картки: сторінка, число,
 * стан завантаження. Відповідь на застарілий запит (клікнули іншу сторінку)
 * відкидається.
 */
export class ClientTendersStore {
    items: TenderRecord[] = []
    total = 0
    page = 1
    isLoading = false
    failed = false

    private clientUuid: string | null = null
    private requestId = 0

    constructor(readonly pageSize: number) {
        makeAutoObservable<ClientTendersStore, 'clientUuid' | 'requestId'>(
            this,
            { clientUuid: false, requestId: false, pageSize: false },
            { autoBind: true }
        )
    }

    bind(clientUuid: string): void {
        if (clientUuid === this.clientUuid) return

        this.clientUuid = clientUuid
        this.page = 1
        void this.reload()
    }

    setPage(page: number): void {
        this.page = page
        void this.reload()
    }

    async reload(): Promise<void> {
        const clientUuid = this.clientUuid

        if (!clientUuid) return

        const requestId = ++this.requestId

        this.isLoading = true
        this.failed = false

        try {
            const { items, total } = await LoadClientTendersTask({ clientUuid, page: this.page, pageSize: this.pageSize })

            if (requestId !== this.requestId) return

            runInAction(() => {
                this.items = items
                this.total = total
            })
        } catch {
            if (requestId !== this.requestId) return

            runInAction(() => {
                this.items = []
                this.total = 0
                this.failed = true
            })
        } finally {
            if (requestId === this.requestId) {
                runInAction(() => {
                    this.isLoading = false
                })
            }
        }
    }
}
